// Navigation bar functionality
import { getDomElements } from '../utils/dom.js';

export function setupNavigation() {
    const domRefs = getDomElements();

    // Initialise nav elements
    updateNavbar();

    // Handle cart button hover effect
    if (domRefs.cartButton) {
        domRefs.cartButton.addEventListener('mouseenter', () => {
            domRefs.cartButton.classList.add('bounce');
        });

        domRefs.cartButton.addEventListener('mouseleave', () => {
            domRefs.cartButton.classList.remove('bounce');
        });
    }
}

export function updateNavbar() {
    const domRefs = getDomElements();
    if (!domRefs.navbar) return;

    // Check if logo in navbar needs updating
    const navLogo = domRefs.navbar.querySelector('.nav__home-link-image');
    if (navLogo) {
        // Set aria-current for current page for accessibility
        const navLinks = domRefs.navbar.querySelectorAll('[data-page]');
        navLinks.forEach(link => {
            const page = link.getAttribute('data-page');
            if (window.location.hash === '#' + page ||
                (window.location.hash === '' && page === 'home')) {
                link.setAttribute('aria-current', 'page');
            } else {
                link.removeAttribute('aria-current');
            }
        });
    }
}